<template>
    <section class="donation-container">
        <DonationBlockComponent :component="component" />
    </section>
</template>

<script lang="ts">
    import { defineComponent } from "vue";
    import DonationBlockComponent from "@/builder/components/donationBlock/DonationBlockComponent.vue";

    export default defineComponent({
        name: "DonationBlockRenderContainer",
        components: {
            DonationBlockComponent,
        },
        props: ["component"]
    });
</script>